import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import type { CalculateMaximumMortgageFormValues } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/schema';
import Group from '~/components/Tools/ToolPanelFormGroup';
import IncomeFieldWithCalculator from '~/components/forms/Tools/CalculateMaximumMortgage/IncomeFieldWithCalculator';
import AgeField from '~/components/forms/Tools/CalculateMaximumMortgage/AgeField';
import BuyWithAPartnerField from '~/components/forms/Tools/CalculateMaximumMortgage/BuyWithAPartnerField';
import { Button } from '~/components/ui/Button';
import { useCalculateMaximumMortgageForm } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/FormProvider';
import { useWatch } from 'react-hook-form';
import { useCalculateMaximumMortgageCalculation } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/CalculationContext';

type IncomeStepProps = {
  onHandleNext: () => void;
};

const IncomeStep: React.FC<IncomeStepProps> = ({ onHandleNext }) => {
  const { control, trigger } = useCalculateMaximumMortgageForm();
  
  const { setHasCalculated } = useCalculateMaximumMortgageCalculation();
  
  const hasPartner = useWatch({
    control,
    name: 'hasPartner',
    defaultValue: false,
  });
  
  const handleNext = async () => {
    setHasCalculated(false);
    const fields: (keyof CalculateMaximumMortgageFormValues)[] = ['income', 'age'];
    if (hasPartner) fields.push('partnerIncome', 'partnerAge');
    const isValid = await trigger(fields);
    if (isValid) onHandleNext();
  }
  
  return (
    <>
      <div>
        <Group>
          <IncomeFieldWithCalculator
            name="income"
            label="Mijn bruto jaarinkomen"
            placeholder="Bruto jaarinkomen"
          />
          <div>
            <AgeField
              name="age"
              label="Leeftijd"
              placeholder="Leeftijd"
            />
          </div>
        </Group>
        <Group>
          <BuyWithAPartnerField
            name="hasPartner"
            label="Wil je samen met een partner kopen?"
          />
        </Group>
        {hasPartner && (
          <Group>
            <IncomeFieldWithCalculator
              name="partnerIncome"
              label="Bruto jaarinkomen van mijn partner"
              placeholder="Bruto jaarinkomen"
            />
            <AgeField
              name="partnerAge"
              label="Leeftijd van mijn partner"
              placeholder="Leeftijd"
            />
          </Group>
        )}
      </div>
      <div className="flex items-center justify-end mt-8">
        <Button variant="primary" type="button" onClick={handleNext}>
          Ga verder
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </div>
    </>
  );
};

export default IncomeStep;